var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"abbonamenti"}},[_c('abstract-pagina-gestione',{attrs:{"tipo-numero":_vm.NUMERO_TESSERE_DEL_TIFOSO}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }